import { render, staticRenderFns } from "./InductionForm.vue?vue&type=template&id=36824ba1&"
import script from "./InductionForm.vue?vue&type=script&lang=js&"
export * from "./InductionForm.vue?vue&type=script&lang=js&"
import style0 from "./InductionForm.vue?vue&type=style&index=0&id=36824ba1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports